import React from "react";
import { X } from "lucide-react";

interface CloseButtonProps {
  handleClose: () => void;
}

const CloseButton: React.FC<CloseButtonProps> = ({ handleClose }) => {
  return (
    <button
      onClick={handleClose}
      type="button"
      className="absolute top-4 right-4 flex items-center gap-1 px-3 py-1.5 text-sm font-medium text-secondary-700 bg-white border border-secondary-200 rounded-lg hover:bg-secondary-50 hover:border-secondary-300 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
      aria-label="Close"
    >
      Close
      <X className="w-4 h-4" />
    </button>
  );
};

export { CloseButton };
